import React from 'react';

import {type Ref as CustomRunNamesRef} from '../../../state/views/customRunNames/types';
import {type WBTableRowWithRunSetInfo} from '../../../util/tablecols';
import {GroupRowHeaderMenu} from './GroupRowHeaderMenu';
import {RunRowHeaderMenu} from './RunRowHeaderMenu';

const spacer = (
  <div style={{height: 32, width: 32, flexGrow: 0, flexShrink: 0}} />
);

type RowHeaderMenuProps = {
  canStopRun: boolean;
  customRunNamesRef: CustomRunNamesRef | undefined;
  isHeaderDropdownEmpty: boolean;
  isGroup: boolean;
  isRunGroup: boolean;
  onCopyRunName: () => void;
  onCopyRunPath: () => void;
  onDeleteRun: () => void;
  onMoveRun: () => void;
  onStopRun: () => void;
  row: WBTableRowWithRunSetInfo;
  visible: boolean;
};

export function RowHeaderMenu({
  canStopRun,
  customRunNamesRef,
  isHeaderDropdownEmpty,
  isGroup,
  isRunGroup,
  onCopyRunName,
  onCopyRunPath,
  onDeleteRun,
  onMoveRun,
  onStopRun,
  row,
  visible,
}: RowHeaderMenuProps) {
  if (isHeaderDropdownEmpty) {
    return spacer;
  }
  if (!isGroup) {
    return (
      <RunRowHeaderMenu
        row={row}
        customRunNamesRef={customRunNamesRef}
        onCopyRunName={onCopyRunName}
        onCopyRunPath={onCopyRunPath}
        onDeleteRun={onDeleteRun}
        onMoveRun={onMoveRun}
        onStopRun={onStopRun}
        canStopRun={canStopRun}
        visible={visible}
      />
    );
  }

  if (isRunGroup) {
    return <GroupRowHeaderMenu row={row} visible={visible} />;
  }

  return null;
}
